import { render, staticRenderFns } from "./UserPermissionsModal.vue?vue&type=template&id=3ea1df1d&scoped=true&"
import script from "./UserPermissionsModal.vue?vue&type=script&lang=js&"
export * from "./UserPermissionsModal.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissionsModal.vue?vue&type=style&index=0&id=3ea1df1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea1df1d",
  null
  
)

export default component.exports